import { ClinicLocation } from '../clinic-location';

export class Doctor {
  public id: number;
  public email: string;
  public default_clinic_location: string;
  public default_patientlist_ordering: number;
  public first_name: string;
  public full_photo: string;
  public is_eu_datetime_format: boolean;
  public last_name: string;
  public locations: ClinicLocation[];
  public new_device_login_notification: boolean;
  public password_expired: boolean;
  public password_reset_notifications: boolean;
  public photo: string;
  public role: number;
  public username: string;
  public fullname: string;
  public clinic: any;
  public date_joined: any;
  public company?: string;
  public phone: string;
  public has_password: boolean;

  public is_active: boolean;
  public _selected: boolean;
  public roleName: string;
  public surgeon: boolean;
  public remote_id: string;

  constructor(data: any = {}) {
    this.id = data.id || void 0;
    this.email = data.email || void 0;
    this.default_clinic_location = data.default_clinic_location || null;
    this.default_patientlist_ordering = data.default_patientlist_ordering;
    this.first_name = data.first_name || void 0;
    this.full_photo = data.full_photo || void 0;
    this.is_eu_datetime_format = data.is_eu_datetime_format;
    this.last_name = data.last_name || void 0;
    this.locations = (data.locations && data.locations.map((loc) => new ClinicLocation(loc))) || [];
    // this.locations = data.locations && data.locations.map((loc) => loc.id ? new ClinicLocation(loc) : loc) || [];
    this.new_device_login_notification = data.new_device_login_notification || void 0;
    this.password_expired = data.password_expired || void 0;
    this.password_reset_notifications = data.password_reset_notifications || void 0;
    this.photo = data.photo || void 0;
    this.role = data.role || void 0;
    this.username = data.username || void 0;
    this.clinic = data.clinic || null;
    this.roleName = data.roleName || void 0;
    this.date_joined = data.date_joined || void 0;
    this.has_password = data.has_password || false;

    this.is_active = data.is_active || false;
    this.fullname = `${this.first_name}, ${this.last_name}`;
    this.company = data.company || void 0;
    this.phone = data.telephone || void 0;
    this._selected = data._selected || void 0;
    this.surgeon = data.surgeon || false;
    this.remote_id = data.remote_id || void 0;
  }

  public get fullName() {
    return `${this.first_name} ${this.last_name}`;
  }

  public get titleName() {
    return `${this.last_name}, ${this.first_name} «${this.username}»`;
  }

  public get description() {
    return `${this.roleName}; ${this.email ? this.email : ''}`;
  }
}
